import BaseModelAPI from '../BaseModelAPI';

export default class UserRoleDetail extends BaseModelAPI {
	static entity = 'userroledetail';
	static entityName = 'userroledetail';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.userRoleId = '';
			this.userRole = {};
			this.roleId = '';
			this.role = {};
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}